// extracted by mini-css-extract-plugin
var _1 = "ra-art-option-frame-item-border";
var _2 = "ra-art-option-frame-item-inner-circle";
var _3 = "ra-art-option-frame-item";
var _4 = "ra-art-option-frame-item-black";
var _5 = "ra-art-option-frame-item-none";
var _6 = "ra-art-option-frame-item-walnut";
var _7 = "ra-art-option-frame-item-white";
var _8 = "ra-art-option-frame-item-inner";
var _9 = "ra-art-option-frame-item-selected";
var _a = "ra-art-option-frame-item-inner-square";
export { _1 as "artFrameItemBorderCls", _2 as "artFrameItemCircleCls", _3 as "artFrameItemCls", _4 as "artFrameItemColorBlackCls", _5 as "artFrameItemColorNoneCls", _6 as "artFrameItemColorWalnutCls", _7 as "artFrameItemColorWhiteCls", _8 as "artFrameItemInnerCls", _9 as "artFrameItemSelectedCls", _a as "artFrameItemSquareCls" }
